import { startLoading, stopLoading, setUserAuth, setError } from './authSlice';
import { AppDispatch } from 'src/store';
import axiosInst from 'src/utils/axiosCreate';

/** Usuario no permitido para acceder al BO: eliminado, inactivo, bloqueado o cuenta inactiva */
export const isUserInactive = (user: any): boolean => {
  if (!user) return true;
  const state = (user.proAccountState || '').toString().toLowerCase();
  if (state === 'deleted' || state === 'inactive') return true;
  if (user.proInactiveAccount === 1 || user.proInactiveAccount === true) return true;
  const proStatusValue = (user.proStatus?.value || '').toString().toLowerCase();
  if (proStatusValue === 'blocked') return true;
  return false;
};

export const usersByEmailOrDU = (userEmail, token?: string) => {
  return async (dispatch: AppDispatch) => {
    const userData = {
      usersDU: '',
      usersEmail: userEmail
    };
    try {
      dispatch(startLoading());
      let resp;
      if (token) {
        resp = await axiosInst.post(`/users/usersByEmailOrDU`, userData, {
          headers: {
            authorizationqp: `Bearer ${token}`
          }
        });
      } else {
        resp = await axiosInst.post(`/users/usersByEmailOrDU`, userData);
      }
      if (!resp) {
        dispatch(setError({ status: resp.status, message: resp.statusText }));
        dispatch(stopLoading());
        return null;
      }
      const user = resp.data.data.users[0];
      if (isUserInactive(user)) {
        dispatch(setError({ statusCode: 403, message: 'Inactive user' }));
        dispatch(stopLoading());
        return { data: resp.data, userInactive: true };
      }
      dispatch(setUserAuth({ user, roles: user.proRoles }));
      dispatch(stopLoading());
      return resp.data;
    } catch (error: any) {
      const resp = error?.response;
      if (resp) {
        dispatch(setError({ status: resp.status, message: resp.data?.message }));
      } else {
        dispatch(setError({ status: 500, message: error?.message || 'Unknown error' }));
      }
      dispatch(stopLoading());
      throw error;
    }
  };
};

